import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { environment } from 'environments/environment';
import { RestService } from 'app/shared/rest.service';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { ResultsSearchService } from 'app/home/results-search.service';
import { NavbarSearchCategoriesComponent } from 'app/shared/navbar-search-categories/navbar-search-categories.component';
import { InfiniteCarousel } from 'app/shared/utils/infinite-carousel';

// Mismo mapeo que usb-promotions (profile-mannagement/promotions), duplicado acá porque
// ese componente no expone estos datos y no se quiere modificar su implementación actual.
const CATEGORY_ORIGIN_MAP: { [categoryId: number]: string } = {
  1: 'HOTELS',
  10: 'INSURANCE',
  6: 'TOURS',
  9: 'TOURS',
};

const CATEGORY_ORIGIN_MODAL_MAP: { [categoryId: number]: string } = {
  1: 'Alojamiento',
  10: 'Asistencia',
};

@Component({
  selector: 'usb-promotions-big',
  templateUrl: './promotions-big.component.html',
  styleUrls: ['./promotions-big.component.scss']
})
export class PromotionsBigComponent implements OnInit {
  @Input() getClientsSettingAppBooking: any;

  @ViewChild('navBarSearchCategories') navBarSearchCategories!: NavbarSearchCategoriesComponent;

  promotions: any[] = [];
  carousel = new InfiniteCarousel<any>();

  private agency: any;

  constructor(
    private restService: RestService,
    private notificationService: NotificationService,
    private resultsSearch: ResultsSearchService,
  ) { }

  ngOnInit(): void {
    this.agency = JSON.parse(localStorage.getItem('selectedAgency') || '{}');
    this.carousel.setViewportWidth(window.innerWidth);
    this.getPromotions();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.carousel.setViewportWidth(window.innerWidth);
  }

  private getPromotions(): void {
    this.restService.doGet_('app', 'promotions-products').subscribe({
      next: (res: any) => {
        if (res && Array.isArray(res.data?.data) && res.data.data.length) {
          this.promotions = res.data.data;
          this.carousel.setItems(this.promotions);
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  applyPromotion(promotion: any): void {
    const origin = CATEGORY_ORIGIN_MAP[promotion.category_catalogue_id];

    if (!origin) {
      this.notificationService.info('Próximamente disponible');
      return;
    }

    const payload = this.buildPromotionPayload(promotion, origin);

    this.resultsSearch._setPayload(null);
    this.resultsSearch._setResponse(null);
    this.resultsSearch._setOrigin(null);

    localStorage.setItem('form', JSON.stringify({}));
    localStorage.setItem('payload', JSON.stringify([payload]));
    localStorage.setItem('origin', origin);

    if (this.navBarSearchCategories) {
      this.navBarSearchCategories.openFormSearch(CATEGORY_ORIGIN_MODAL_MAP[promotion.category_catalogue_id]);
    }
  }

  private getSearchDates(promotion: any): { start: string; end: string } {
    const start = promotion.travel_window_start || promotion.booking_window_start;
    const end = promotion.travel_window_end || promotion.booking_window_end;

    return {
      start: start ? moment(start).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
      end: end ? moment(end).format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD'),
    };
  }

  private buildPromotionPayload(promotion: any, origin: string): any {
    const { start, end } = this.getSearchDates(promotion);
    const country = this.agency?.country || '';

    const payload: any = {
      providersId: null,
      categoriesId: [promotion.category_catalogue_id],
      agencyId: this.agency?.agency_id,
      nationality: country,
      country,
      arrivalDate: start,
      departureDate: end,
      others: {
        maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
        minNumResults: environment.minNumResults,
        maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
      },
    };

    switch (origin) {
      case 'HOTELS':
        payload.origin = '';
        payload.destination = promotion.cities?.[0] || '';
        payload.city = promotion.cities?.[0] || '';
        payload.priceFrom = 0;
        payload.priceTo = 20000;
        payload.qtyProduct = 1;
        payload.qtyPax = 1;
        payload.agencyCountry = country;
        payload.page = 1;
        payload.per_page = 10;
        if (promotion.hotel_id || promotion.promotable_id) {
          payload.hotels = [promotion.hotel_id || promotion.promotable_id];
        }
        payload.others.hotels = {
          roomConfiguration: [{ adults: 1, children: [] }],
        };
        break;

      case 'INSURANCE':
        payload.dateBegin = start;
        payload.dateEnd = end;
        payload.market = 2;
        payload.contact = { wsp_phone_contact: '', email_contact: '' };
        payload.insurances = {
          origin: country,
          destination: promotion.countries?.[0] && promotion.countries[0] !== 'ALL' ? promotion.countries[0] : country,
          tripType: 'Viaje Vacacional',
          paxList: [
            {
              qtyPax: 1,
              paxAges: [21],
              hasPreExistingCondition: false,
              isPregnant: false,
              isOnTrip: false,
              pregnancyWeeks: null,
            },
          ],
        };
        break;

      case 'TOURS':
        payload.origin = '';
        payload.destination = promotion.cities?.[0] || '';
        payload.city = promotion.cities?.[0] || '';
        payload.priceFrom = 0;
        payload.priceTo = 20000;
        payload.market = 2;
        payload.others.tours = { adults: 1, children: [] };
        break;
    }

    return payload;
  }

}
